import styled from 'styled-components'

const NaglowekSprStyle = styled.div`
  main {
    width: 304px;
    height: 136px;
    color: #fff;
    padding: 12px;
    * {
      margin: 0;
    }
    position: relative;
  }

  div {
    ${'' /* <jajko> */}
    /* width: 64px;
    height: 84px;
    border-radius: 50% 50% 50% 50% / 65% 65% 35% 35%;
    background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.2) 15%,
          transparent 25%
        ) -5px 0,
      linear-gradient(225deg, rgba(255, 255, 255, 0.2) 15%, transparent 25%) -5px
        0,
      linear-gradient(315deg, rgba(255, 255, 255, 0.2) 15%, transparent 25%),
      linear-gradient(45deg, rgba(255, 255, 255, 0.2) 15%, transparent 25%);
    background-size: 8px 16px; */
    ${'' /* </jajko> */}

    position: absolute;
    border-radius: 50%; 
    width: 68px; 
    height: 68px; 
    top: 16px;
    right: 16px;
    display: grid;
    justify-content: center;
    align-content: center;
  }

  main.SprFinJednostkaInnaWZlotych,
  div.SprFinJednostkaInnaWTysiacach {
    background-color: ${props => props.theme.ticket_IN_dark};
  }
  main.SprFinJednostkaMalaWZlotych,
  div.SprFinJednostkaMalaWTysiacach {
    background-color: ${props => props.theme.ticket_MA_dark};
  }
  main.SprFinJednostkaMikroWZlotych,
  div.SprFinJednostkaMikroWTysiacach {
    background-color: ${props => props.theme.ticket_MI_dark};
  }
  main.SprFinOpWZlotych,
  div.SprFinOpWTysiacach {
    background-color: ${props => props.theme.ticket_OP_dark};
  }
  main.SprFinDomMaklerskiWZlotych,
  div.SprFinDomMaklerskiWTysiacach {
    background-color: ${props => props.theme.ticket_DM_dark};
  }
  main.SprFinSkonsolidowanaJednostkaInnaWZlotych,
  div.SprFinSkonsolidowanaJednostkaInnaWTysiacach {
    background-color: ${props => props.theme.ticket_SIN_dark};
  }

  div.SprFinJednostkaInnaWZlotych,
  main.SprFinJednostkaInnaWTysiacach {
    background-color: ${props => props.theme.ticket_IN_light};
  }
  div.SprFinJednostkaMalaWZlotych,
  main.SprFinJednostkaMalaWTysiacach {
    background-color: ${props => props.theme.ticket_MA_light};
  }
  div.SprFinJednostkaMikroWZlotych,
  main.SprFinJednostkaMikroWTysiacach {
    background-color: ${props => props.theme.ticket_MI_light};
  }
  div.SprFinOpWZlotych,
  main.SprFinOpWTysiacach {
    background-color: ${props => props.theme.ticket_OP_light};
  }
  div.SprFinDomMaklerskiWZlotych,
  main.SprFinDomMaklerskiWTysiacach {
    background-color: ${props => props.theme.ticket_DM_light};
  }
  div.SprFinSkonsolidowanaJednostkaInnaWZlotych,
  main.SprFinSkonsolidowanaJednostkaInnaWTysiacach {
    background-color: ${props => props.theme.ticket_SIN_light};
  }

  p {
    color: ${props => props.theme.white60};
    font-family: 'Ubuntu';
    font-weight: 400;
    font-size: 11px;
    letter-spacing: 0.4px;
    margin-top: 26px;
  }
  h2 {
    font-family: 'Ubuntu-Medium';
    font-weight: 500;
    font-size: 36px;
    letter-spacing: 0.3px;
  }
  h3 {
    font-family: 'Ubuntu-Bold';
    font-weight: 700;
    font-size: 11px;
    letter-spacing: 1.5px;
  }
  h4 {
    font-family: 'Ubuntu';
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.2px;
    margin-top: 12px;
  }
  h5,
  span {
    font-family: 'Ubuntu';
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.3px;
    color: #fff;
    margin-top: 4px;
  }
`

export default NaglowekSprStyle
